import type { TalentAppRouter } from '@nemo/api';
import { createTRPCContext } from '@trpc/tanstack-react-query';

export const { TRPCProvider: TalentTRPCProvider, useTRPC: useTalentTRPC } =
  createTRPCContext<TalentAppRouter>();
